export default __webpack_public_path__ + "static/media/stemmaa.90007b9a.png";